import AppBar, {AppBarProps} from "material-ui/AppBar";
import {colors} from "material-ui/styles";


const style = {
  backgroundColor: colors.cyan600,
};


/**
 * App bar with darker background to use on sidebars.
 */
const SecondaryAppBar = (props: AppBarProps) => {
  return <AppBar {...props} style={Object.assign({}, style, props.style)}/>;
};


export default SecondaryAppBar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/SecondaryAppBar.tsx